import {BaseStore, globalStore} from "../../../stem-core/state/Store.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {BaseEnum, makeEnum} from "../../../stem-core/state/BaseEnum.js";
import {AuthService, authService} from "../../connection/services/AuthService.js";
import {Merchant} from "../MerchantStore";
import {MerchantAudience} from "./MerchantAudienceStore";
import {UserProfile} from "../UserProfileStore";
import {StemDate} from "../../../stem-core/time/Date";
import {MerchantConversion} from "./MerchantConversionStore";


@makeEnum
export class MerchantAudienceMemberStatus extends BaseEnum {
    static SELF_SUBSCRIBED;
    static MANUALLY_SUBSCRIBED;
    static AUTO_SUBSCRIBED;
    static SELF_UNSUBSCRIBED;
    static MANUALLY_UNSUBSCRIBED;
    static AUTO_UNSUBSCRIBED;
    static RULE_SUBSCRIBED;
}

export const ProperSubscribedStatuses = [MerchantAudienceMemberStatus.SELF_SUBSCRIBED, MerchantAudienceMemberStatus.MANUALLY_SUBSCRIBED, MerchantAudienceMemberStatus.AUTO_SUBSCRIBED];
export const SubscribedStatuses = [...ProperSubscribedStatuses, MerchantAudienceMemberStatus.RULE_SUBSCRIBED];
export const ProperUnsubscribedStatuses = [MerchantAudienceMemberStatus.SELF_UNSUBSCRIBED, MerchantAudienceMemberStatus.MANUALLY_UNSUBSCRIBED, MerchantAudienceMemberStatus.AUTO_UNSUBSCRIBED];
export const UnsubscribedStatuses = ProperUnsubscribedStatuses;
export const ProperStatuses = [...ProperSubscribedStatuses, ...ProperUnsubscribedStatuses];

@globalStore
export class MerchantAudienceMember extends BaseStore("MerchantAudienceMember") {
    @field("Merchant") merchant: Merchant;
    @field(Number) audienceId: number;
    @field("MerchantAudience") audience: MerchantAudience;
    @field("UserProfile") user: UserProfile;
    @field(MerchantAudienceMemberStatus) status: MerchantAudienceMemberStatus;
    @field(Date) unsubscribedAt: StemDate;
    @field(Date) subscribedAt: StemDate;
    @field(Date) createdAt: StemDate;
    @field(Number) conversionId: number;
    @field("MerchantConversion") conversion: MerchantConversion;

    isSubscribed() {
        return SubscribedStatuses.indexOf(this.status) >= 0;
    }

    serializeForSDK() {
        const {audienceId, status, subscribedAt, unsubscribedAt, conversionId} = this;
        return {
            status: status.valueOf(),
            audienceId,
            subscribedAt,
            unsubscribedAt,
            conversionId,
            name: this.audience?.name,
        }
    }
}

export async function apiGetNewsletterSubscriptions(request, noAuthToken=false) {
    return apiClient.get("/users/get_newsletter_subscriptions", request, {noAuthToken});
}

export const NewsletterSubscriptionUpdateType = {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    REPLACE: "replace",
}

// TODO @branch make this subscribe the user to a non-public newsletter
export async function apiUserUpdateNewsletterSubscriptions(request, noAuthToken=false) {
    const response = await apiClient.post("/users/update_newsletter_subscriptions", request, {noAuthToken});
    // We may have been automatically logged in here.
    if (authService.hasAuthToken(response)) {
        // We've been auto-authenticated via registration, since this merchant doesn't care about confirmation codes on new visits
        authService.setAuthToken(response);
        authService.dispatch(AuthService.EventTypes.USER_DATA_AVAILABLE, response);
    }
    return response;
}

export async function apiMerchantCreateAudienceMembers(request) {
    return apiMerchantEditAudienceMembers(request);
}

export async function apiMerchantEditAudienceMembers(request) {
    return apiClient.post("/merchant/edit_audience_members", request);
}
